<script>
    import { path } from 'd3-path';
    import { getContext } from 'svelte';


    // --- Properties
    export let width;
    export let height;   

    // --- Match (control) positions
    export let dataKey;
    const { matches, activeMatch: active, orderCar, orderCC } = getContext(dataKey);
    
    $: car2match = makePathsCar2Match($matches, $orderCar);
    $: match2cc = makePathsMatch2CC($matches, $orderCC);

    function makePathsCar2Match(matches, orderCar) {
        const yMap = orderCar.reduce((map, car, i) => {
            map[car] = y(i);
            return map;
        }, {});

        return matches.map((match, i) => {
            if (!(match.car in yMap)) {
                return '';
            }
            
            const yMatch = y(i);
            const yCar = yMap[match.car];

            const p = path();
            p.moveTo(70, yCar);
            p.bezierCurveTo(
                70 + 35, yCar,
                140 - 35, yMatch,
                140, yMatch)
            return p.toString();
        });
    }

    function makePathsMatch2CC(matches, orderCC) {
        const yMap = orderCC.reduce((map, cc, i) => {
            map[cc] = y(i);
            return map;
        }, {});

        return matches.map((match, i) => {
            if (!(match.ccnum in yMap)) {
                return '';
            }
            
            const yMatch = y(i);
            const yCC = yMap[match.ccnum];
            
            const p = path();
            p.moveTo(225, yMatch);
            p.bezierCurveTo(
                225 + 30, yMatch,
                285 - 30, yCC,
                285, yCC)
            return p.toString();
        });
    }

    function y(i) {
        return 80 + i * 20 + 10;
    }
</script>

<svg {width} {height}>
    {#each $matches as match, i}
        <!-- svelte-ignore component-name-lowercase -->
        <path class='path' class:fade={!$active[i]}
              d = {car2match[i]} stroke='currentColor' fill='transparent' />
        <!-- svelte-ignore component-name-lowercase -->
        <path class='path' class:fade={!$active[i]}
              d = {match2cc[i]} stroke='currentColor' fill='transparent' />
    {/each}
</svg>

<style>
svg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
}

.path.fade {
    opacity: 0.3;
}
</style>